<template>
  <div
    class="fixed right-10 xl:right-4 bottom-4 flex flex-row gap-2"
  >
    <div
      v-if="duplication"
      class="w-16 h-16 cursor-pointer text-white text-4xl flex flex-row justify-center items-center bg-overlay2 rounded"
      title="Duplicate (Keyboard: D)"
      @click="doDuplicate"
    >
      <i class="far fa-copy"/>
    </div>

    <div
      v-if="rotation"
      class="w-16 h-16 cursor-pointer text-white text-4xl flex flex-row justify-center items-center bg-overlay2 rounded"
      title="Rotate (Keyboard: R)"
      @click="doRotate"
    >
      <i class="fas fa-sync-alt"/>
    </div>

    <div
      v-if="removal"
      class="w-16 h-16 text-5xl flex flex-row justify-center items-center bg-overlay2 rounded text-red-600 cursor-pointer"
      title="Delete (Keyboard: Del or X)"
      @click="doRemove"
    >
      <i class="fas fa-times"/>
    </div>

    <div
      class="w-16 h-16 cursor-pointer text-red-600 text-5xl flex flex-row justify-center items-center bg-overlay2 rounded"
      title="Cancel (Keyboard: Esc)"
      @click="doCancel"
    >
      <i class="fas fa-ban"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    duplication: {
      type: Boolean,
      required: true
    },
    rotation: {
      type: Boolean,
      required: true
    },
    removal: {
      type: Boolean,
      required: true
    }
  },
  emits: ['duplicate', 'rotate', 'remove', 'cancel'],
  setup(_, context) {
    return {
      doDuplicate() {
        context.emit('duplicate');
      },
      doRotate() {
        context.emit('rotate');
      },
      doRemove() {
        context.emit('remove');
      },
      doCancel() {
        context.emit('cancel');
      }
    }
  }
};
</script>
